import { useLocalStorage } from "../../../hooks/use-local-storage"

const DRAWER_STATE_LOCAL_STORAGE_KEY = "starbrix_app_drawer_state"

const INITIAL_STATE: DrawerState = {
  isDrawerOpen: window.innerWidth > 800,
  isResourceNavOpen: false,
  drawerOpenReason: null,
}

export const useAppDrawer = () => {
  const [drawerState, setDrawerState] = useLocalStorage<DrawerState>(DRAWER_STATE_LOCAL_STORAGE_KEY, INITIAL_STATE)

  const openDrawer = (reason: string) => {
    setDrawerState((state) => ({ ...state, isDrawerOpen: true, drawerOpenReason: reason }))
  }

  const closeDrawer = () => {
    setDrawerState({ isResourceNavOpen: false, isDrawerOpen: false, drawerOpenReason: null })
  }

  const toggleResourceNav = () => {
    setDrawerState((state) => {
      const nextIsResourceOpen = !state.isResourceNavOpen
      const nextIsDrawerOpen = nextIsResourceOpen || state.isDrawerOpen
      return { ...state, isResourceNavOpen: nextIsResourceOpen, isDrawerOpen: nextIsDrawerOpen }
    })
  }

  const { isDrawerOpen, isResourceNavOpen, drawerOpenReason } = drawerState

  return {
    isDrawerOpen,
    isResourceNavOpen,
    drawerOpenReason,
    openDrawer,
    closeDrawer,
    toggleResourceNav,
    setDrawerState, // Expose setter for more complex updates if needed
  }
}

type DrawerState = {
  isDrawerOpen: boolean
  isResourceNavOpen: boolean
  drawerOpenReason: string | null
}
